const BASE_API_URL = "https://tesseract-v2.curefit.co";

// Helper function to get cookie value
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

document.addEventListener("DOMContentLoaded", () => {
  function hasReactCheckoutPath() {
    return !!document.querySelector(".js-cart-drawer");
  }

  function triggerReactCheckout(context = {}) {
    if (window.CultStoreSentry) {
      window.CultStoreSentry.addBreadcrumb(
        "Routing checkout through React cart",
        "checkout",
        context,
      );
    }

    document.dispatchEvent(
      new CustomEvent("dispatch:checkout:react", {
        bubbles: true,
        cancelable: false,
      }),
    );
  }

  // Hide alternative login options in webview environments
  const ssoContainer = document.querySelector('.sso-login__container');
  const isWebview = detectWebview();
  if (ssoContainer && isWebview) {
    const altLogin = ssoContainer.querySelector('.alternative--login__options');
    if (altLogin) {
      altLogin.style.display = 'none';
    }
  }

  // Helper to close the SSO login popup
  function closeSsoLoginPopup() {
    const popup = document.querySelector('sso-login-popup');
    if (!popup?.classList.contains('active')) return;
    popup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (window.SsoLogin?.activeInstance) {
      window.SsoLogin.activeInstance = null;
    }
  }
  
  // Global close handler for all .close--btn and modal-overlay
  document.addEventListener('click', function(event) {
    if (event.target.closest('.close--btn') || event.target.closest('modal-overlay')) {
      closeSsoLoginPopup();
    }
  });

  // Esc key support to close the popup
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeSsoLoginPopup();
    }
  });

  // Fallback cookie-based resume (used if sessionStorage write failed)
  const hasResumeCookie = document.cookie.includes('resumeCheckout=1');
  function clearCheckoutResumeState() {
    try {
      sessionStorage.removeItem("openCheckout");
    } catch(e) {
      // sessionStorage may be unavailable in some webviews.
    }
    document.cookie = 'resumeCheckout=1; path=/; max-age=0; SameSite=Lax';
  }

  setTimeout(() => {
    try {
      const sessionOpenCheckout = sessionStorage.getItem("openCheckout");
      const shouldOpenCheckout = sessionOpenCheckout || hasResumeCookie;
      
      if (shouldOpenCheckout) {
        clearCheckoutResumeState();
        const checkoutBtn = document.querySelector("marmeto-checkout-button");
        if (checkoutBtn) {
          if (window.CultStoreSentry) {
            window.CultStoreSentry.addBreadcrumb('Auto-resuming checkout from storage', 'checkout', {
              fromSessionStorage: !!sessionOpenCheckout,
              fromCookie: hasResumeCookie
            });
          }
          checkoutBtn.click();
        } else {
          if (hasReactCheckoutPath()) {
            triggerReactCheckout({
              trigger: "auto_resume",
              fromSessionStorage: !!sessionOpenCheckout,
              fromCookie: hasResumeCookie,
            });
          } else if (window.CultStoreSentry) {
            window.CultStoreSentry.addBreadcrumb('Checkout auto-resume skipped: no checkout route on page', 'checkout', {
              hadOpenCheckoutFlag: true,
              fromSessionStorage: !!sessionOpenCheckout,
              fromCookie: hasResumeCookie
            });
          }
        }
      }
    } catch(e) {
      if (window.CultStoreSentry) {
        window.CultStoreSentry.captureCheckoutError(e, {
          stage: 'auto_resume',
          message: e.message
        });
      }
    }
  }, 1000);
  
  document.addEventListener("dispatch:checkout:open", () => {
    try {
      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:open", {
          bubbles: true,
          cancelable: false,
        }),
      );
      
      const checkoutBtn = document.querySelector("marmeto-checkout-button");
      if (checkoutBtn) {
        if (window.CultStoreSentry) {
          window.CultStoreSentry.addBreadcrumb('Checkout triggered via dispatch:checkout:open', 'checkout');
        }
        checkoutBtn.click();
      } else {
        if (hasReactCheckoutPath()) {
          triggerReactCheckout({
            trigger: "dispatch:checkout:open",
          });
        } else {
          try {
            sessionStorage.setItem("openCheckout", "true");
          } catch(e) {
            document.cookie = 'resumeCheckout=1; path=/; max-age=120; SameSite=Lax';
          }

          if (window.CultStoreSentry) {
            window.CultStoreSentry.captureSilentFailure('Checkout button not found on dispatch event', {
              type: 'missing_element',
              component: 'marmeto-checkout-button',
              trigger: 'dispatch:checkout:open'
            });
          }
        }
      }
    } catch(e) {
      if (window.CultStoreSentry) {
        window.CultStoreSentry.captureCheckoutError(e, {
          stage: 'dispatch_checkout_open',
          message: e.message
        });
      }
    }
  });
});

function detectWebview(platform = false) {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS WebView Detection
  const isIOS = /iPhone|iPod|iPad/.test(userAgent);
  const isSafari =
    /Safari/.test(userAgent) || /CriOS|FxiOS|EdgiOS/.test(userAgent); // Exclude Chrome, Firefox, Edge
  const isIOSWebView =
    isIOS &&
    !isSafari &&
    (navigator.standalone === false || /AppleWebKit/.test(userAgent));

  // Android WebView Detection
  const isAndroid = /Android/.test(userAgent);
  const isAndroidWebView =
    (isAndroid && /wv/.test(userAgent)) ||
    (isAndroid &&
      /Version\/\d+\.\d+/.test(userAgent) &&
      !/Chrome/.test(userAgent));

  // React Native WebView Detection
  const isReactNativeWebView = !!window.ReactNativeWebView;
  // console.log("isIOSWebView", isIOSWebView, "isAndroidWebView", isAndroidWebView, "isReactNativeWebView", isReactNativeWebView);

  return platform
    ? {
        android: isAndroidWebView,
        isWebview: isIOSWebView || isAndroidWebView || isReactNativeWebView,
      }
    : isIOSWebView || isAndroidWebView || isReactNativeWebView;
}

/* ---------------- Checkout Reliability Helpers (Phase 1 & 2) ---------------- */
// Minimal, additive utilities – no large refactor.
// Guard all Sentry calls: theme may load before Sentry SDK.
const CHECKOUT_ERROR_CODES = {
  REENTRY: 'CHECKOUT_REENTRY_BLOCKED',
  CART_EMPTY: 'CART_EMPTY_AT_CLICK',
  SESSION_TIMEOUT: 'SESSION_FETCH_TIMEOUT',
  SESSION_ERROR: 'SESSION_FETCH_ERROR',
  PHONE_MODAL_MISSING: 'PHONE_MODAL_MISSING',
  PAYLOAD_BUILD_ERROR: 'PAYLOAD_BUILD_ERROR',
  PAYLOAD_API_TIMEOUT: 'PAYLOAD_API_TIMEOUT',
  BREEZE_SDK_UNAVAILABLE: 'BREEZE_SDK_UNAVAILABLE',
  BREEZE_START_FAILED: 'BREEZE_START_FAILED',
  UNKNOWN: 'UNKNOWN_EXCEPTION',
  STG_VALUE_CORRUPT: 'STG_VALUE_CORRUPT',
  STG_CRITICAL_WRITE_FAIL: 'STG_CRITICAL_WRITE_FAIL',
  STG_CRITICAL_RELOAD: 'STG_CRITICAL_RELOAD',
  STG_RELOAD_LOOP_ABORT: 'STG_RELOAD_LOOP_ABORT',
  GLOBAL_TIMEOUT: 'CHECKOUT_GLOBAL_TIMEOUT',
  STUCK_ON_MOUNT: 'CHECKOUT_STUCK_ON_MOUNT',
  CART_FETCH_ERROR: 'CART_FETCH_ERROR',
  CART_PARSE_ERROR: 'CART_PARSE_ERROR'
};

function reportCheckoutBreadcrumb(message, data = {}) {
  try {
    if (window.Sentry && window.Sentry.addBreadcrumb) {
      window.Sentry.addBreadcrumb({ category: 'checkout', level: 'info', message, data });
    }
  } catch (_) {}
}

function reportCheckoutError(code, context = {}, level = 'error') {
  const payload = { code, ...context };
  reportCheckoutBreadcrumb('error:' + code, context);
  try {
    // Prefer CultStoreSentry for enriched user/cart context
    if (window.CultStoreSentry && window.CultStoreSentry.captureCheckoutError) {
      const err = new Error('Checkout flow error: ' + code);
      err.name = 'CheckoutError';
      err.code = code;
      
      // Prepare enriched context
      const enrichedContext = {
        stage: 'checkout_flow',
        checkoutCode: code,
        checkoutPhase: context.phase || 'unknown',
        checkoutAttempt: context.attempt || 0,
        errorLevel: level,
        retry: context.retry,
        message: context.message,
        detail: context.detail,
        pageUrl: window.location.href,
        timestamp: new Date().toISOString(),
      };
      
      // Add cart summary if available
      try {
        if (window.cart && window.cart.items) {
          enrichedContext.cartItemCount = window.cart.items.length;
          enrichedContext.cartTotalPrice = window.cart.total_price;
        }
      } catch (_) {}
      
      // Only report errors and warnings, not info level
      if (level !== 'info') {
        window.CultStoreSentry.captureCheckoutError(err, enrichedContext);
      }
      
      // Dispatch event for analytics (MoEngage/DataLake)
      if (level !== 'info' && window.eventStreaming && typeof window.eventStreaming.dispatchErrorEvent === 'function') {
        try {
          window.eventStreaming.dispatchErrorEvent(code, {
            ...enrichedContext,
            errorCategory: 'checkout',
            sessionId: getCookie('_shopify_y') || 'unknown',
            deviceId: getCookie('_shopify_y') || 'unknown',
          });
        } catch (e) {
          console.error('[Checkout] Error dispatching analytics event:', e);
        }
      }
      
    } else if (window.Sentry) {
      // Fallback to direct Sentry
      const scopeFn = (scope) => {
        scope.setTag('checkout_code', code);
        if (context.attempt != null) scope.setTag('checkout_attempt', context.attempt);
        if (context.phase) scope.setTag('checkout_phase', context.phase);
        // Avoid leaking PII – do not attach raw phone numbers.
        Object.keys(context).forEach(k => {
          if (typeof context[k] === 'string' && /phone/i.test(k)) return; // skip
        });
        scope.setFingerprint && scope.setFingerprint(['checkout', code]);
        if (context.extra) scope.setContext('checkout_extra', context.extra);
      };
      if (level === 'error') {
        window.Sentry.captureException(new Error(code), scopeFn);
      } else if (level === 'warning') {
        window.Sentry.captureMessage(code, scopeFn);
      } else {
        // info level – breadcrumb already added; reduce noise.
      }
    } else {
      // Fallback console logging for local debugging.
      if (level !== 'info') console.warn('[CheckoutError]', code, context);
    }
    
    // Always dispatch custom event for immediate handling (even without Sentry)
    if (level !== 'info') {
      try {
        document.dispatchEvent(new CustomEvent('CHECKOUT_ERROR', {
          detail: {
            errorCode: code,
            ...context,
            errorLevel: level,
            timestamp: new Date().toISOString(),
          }
        }));
      } catch (e) {
        console.error('[Checkout] Error dispatching custom event:', e);
      }
    }
  } catch (e) {
    // never throw from reporter but log it
    console.error('[Checkout] Error reporting failed:', e);
  }
}

function withTimeout(promise, ms, timeoutCode) {
  let timer;
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      timer = setTimeout(() => {
        const err = new Error('Timeout: ' + timeoutCode);
        err._checkoutCode = timeoutCode;
        reject(err);
      }, ms);
    })
  ]).finally(() => clearTimeout(timer));
}

/**
 * Wait for Breeze SDK to be ready
 * Uses the centralized SDK from breeze-sdk.js if available
 */
async function waitForBreezeSDK(totalMs = 2000) {
  // Use centralized breeze SDK if available
  if (window.checkoutHelpers && typeof window.checkoutHelpers.waitForSDK === 'function') {
    return await window.checkoutHelpers.waitForSDK(totalMs);
  }
  
  // Fallback to inline check
  const start = Date.now();
  const intervals = [50, 100, 200, 400, 800, 400];
  for (let d of intervals) {
    if (typeof window.Breeze !== 'undefined' || 
        typeof window.breezeCheckout !== 'undefined' ||
        (window.BlazeSDK && typeof window.BlazeSDK.process === 'function')) {
      return true;
    }
    if (Date.now() - start >= totalMs) break;
    // eslint-disable-next-line no-await-in-loop
    await new Promise(r => setTimeout(r, d));
  }
  return (typeof window.Breeze !== 'undefined' || 
          typeof window.breezeCheckout !== 'undefined' ||
          (window.BlazeSDK && typeof window.BlazeSDK.process === 'function'));
}

function startCheckoutTransaction() {
  try {
    if (window.Sentry && window.Sentry.startTransaction) {
      return window.Sentry.startTransaction({ name: 'CheckoutFlow', op: 'ui.action' });
    }
  } catch (_) {}
  return null;
}

function tagTransactionPhase(tx, phase) {
  if (!tx) return;
  try {
    tx.setTag('checkout_phase', phase);
    tx.setData && tx.setData('phase', phase);
  } catch (_) {}
}

function finalizeTransaction(tx, status, code) {
  if (!tx) return;
  try {
    tx.setTag('checkout_status', status);
    if (code) tx.setTag('checkout_final_code', code);
    tx.finish();
  } catch (_) {}
}
/* ---------------- End Helpers ---------------- */

/* ---------------- Resilient Storage (Critical keys + appliedOffer) ---------------- */
const resilientStorage = (() => {
  let tested = false;
  let availability = { local: true, session: true };

  function test() {
    if (tested) return availability;
    tested = true;
    try {
      const k = '__rs_ls__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
    } catch(e) { availability.local = false; }
    try {
      const k = '__rs_ss__';
      sessionStorage.setItem(k, '1');
      sessionStorage.removeItem(k);
    } catch(e) { availability.session = false; }
    return availability;
  }

  function getJSONLocal(key) {
    try {
      if (!test().local) return null;
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      try { return JSON.parse(raw); } catch(parseErr) {
        reportCheckoutError(CHECKOUT_ERROR_CODES.STG_VALUE_CORRUPT, { key, rawLength: raw.length }, 'warning');
        try { localStorage.removeItem(key); } catch(_) {}
        return null;
      }
    } catch(e) { return null; }
  }

  function setCriticalOpenCheckout() {
    const avail = test();
    let wrote = false;
    if (avail.session) {
      try {
        sessionStorage.setItem('openCheckout', 'true');
        wrote = sessionStorage.getItem('openCheckout') === 'true';
      } catch(e) {
        reportCheckoutError(CHECKOUT_ERROR_CODES.STG_CRITICAL_WRITE_FAIL, { target: 'sessionStorage', message: e.message }, 'warning');
      }
    }
    if (!wrote) {
      const alreadyHad = document.cookie.includes('resumeCheckout=1');
      document.cookie = 'resumeCheckout=1; path=/; max-age=120; SameSite=Lax';
      if (!alreadyHad) {
        reportCheckoutError(CHECKOUT_ERROR_CODES.STG_CRITICAL_RELOAD, { target: 'openCheckout', sessionAvailable: avail.session, localAvailable: avail.local }, 'info');
        setTimeout(() => { try { window.location.reload(); } catch(_) {} }, 50);
      } else {
        reportCheckoutError(CHECKOUT_ERROR_CODES.STG_RELOAD_LOOP_ABORT, { target: 'openCheckout' }, 'warning');
      }
    }
  }

  return { test, getJSONLocal, setCriticalOpenCheckout };
})();
/* ---------------- End Resilient Storage ---------------- */

class SsoLogin extends HTMLElement {
  static activeInstance = null;
  constructor() {
    super();
    this.userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = this.userAgent.includes("android");
    this.togglePopupHandler = this.togglePopup.bind(this);
    this.isPopupOpen = false;
  }

  connectedCallback() {
    this.addEventListener("click", this.togglePopupHandler);

    const closeButton = document.querySelector("sso-close-button");
    const phoneUpdateCloseButton = document.querySelector(
      "phone-update-close-button",
    );
    const modalOverlay = document.querySelector("modal-overlay");

    [closeButton, phoneUpdateCloseButton, modalOverlay].forEach(
      this.attachCloseHandler.bind(this),
    );
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.togglePopupHandler);

    const closeButton = document.querySelector("sso-close-button");
    const phoneUpdateCloseButton = document.querySelector(
      "phone-update-close-button",
    );
    const modalOverlay = document.querySelector("modal-overlay");

    [closeButton, phoneUpdateCloseButton, modalOverlay].forEach(
      this.detachCloseHandler.bind(this),
    );
  }

  attachCloseHandler(element) {
    if (element) {
      element.addEventListener("click", this.togglePopupHandler);
    }
  }

  detachCloseHandler(element) {
    if (element) {
      element.removeEventListener("click", this.togglePopupHandler);
    }
  }

  clearSessionStorage(key) {
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }

  clearInputs() {
    document.querySelector('phone-login input[name="phone-number"]').value = "";
    const otpHolders = Array.from(document.querySelectorAll(".otp--holder"));
    const otpValidationInput = document.getElementById("otp-validation-input");

    const phoneLoginContinueBtn = document.querySelector(
      "phone-login .continue--button",
    );
    const otpConfirmBtn = document.querySelector("otp-confirm-button");

    if (!this.otpDigits || this.otpDigits.length !== otpHolders.length) {
      this.otpDigits = new Array(otpHolders.length).fill("");
    }

    otpHolders.forEach((holder, index) => {
      holder.textContent = "";
      this.otpDigits[index] = "";
    });

    otpConfirmBtn.setAttribute("disabled", "true");

    otpValidationInput.value = "";
    phoneLoginContinueBtn.setAttribute("disabled", "true");
  }

  closePopup() {
    const popup = document.querySelector("sso-login-popup");
    if (!popup) return;

    popup.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    this.isPopupOpen = false;

    if (SsoLogin.activeInstance === this) {
      SsoLogin.activeInstance = null;
    }
  }

  togglePopup(event) {
    event?.preventDefault();

    const popup = document.querySelector("sso-login-popup");
    if (popup) {
      if (this.isPopupOpen) {
        this.closePopup();
      } else {
        if (SsoLogin.activeInstance && SsoLogin.activeInstance !== this) {
          SsoLogin.activeInstance?.closePopup();
        }

        popup.classList.add("active");
        document.dispatchEvent(new CustomEvent("event:login:init"));
        document.querySelector("sso-login-container")?.initListeners();
        document.body.classList.add("overflow-hidden");
        this.clearSessionStorage("openCheckout");
        this.clearInputs();

        if (popup.classList.contains("active") && this.isAndroid) {
          this.checkAndOpenTruecaller();
        }

        this.isPopupOpen = true;
        SsoLogin.activeInstance = this;
      }
      // if it's login page or register page then redirect to homepage on popup close
      if (
        !popup.classList.contains("active") &&
        ["/account/login", "/account/register"].some((path) =>
          window.location.pathname.includes(path),
        )
      ) {
        window.location.href = "/";
      }
    }
  }

  checkAndOpenTruecaller() {
    let isTruecallerInstalled = false;
    const truecallerURL = "truecaller://";
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = truecallerURL;
    document.body.appendChild(iframe);

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (isTruecallerInstalled) {
          const truecallerLoginElement =
            document.querySelector("truecaller-login");
          truecallerLoginElement?.onSubmit();
        }
        document.body.removeChild(iframe);
      }, 500);
    });

    window.addEventListener(
      "blur",
      () => {
        isTruecallerInstalled = true;
      },
      { once: true },
    );
  }
}

customElements.define("sso-login", SsoLogin);

class SsoLoginContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add("active");
    this.initListeners();
  }

  initListeners() {
    const phoneLoginForm = this.querySelector("phone-login > form");
    const socialLogin = this.querySelector("social-login");
    const alternativeSocialLogin = this.querySelector(
      "alternative-social-login",
    );
    const alternativePhoneLogin = this.querySelector("alternative-phone-login");

    if (
      phoneLoginForm &&
      socialLogin &&
      alternativeSocialLogin &&
      alternativePhoneLogin
    ) {
      // Set initial states
      this.setDisplayStyles(
        phoneLoginForm,
        socialLogin,
        alternativeSocialLogin,
        alternativePhoneLogin,
        true,
      );

      // Add event listeners for toggling login forms
      this.addToggleListener(
        alternativeSocialLogin,
        phoneLoginForm,
        socialLogin,
        alternativeSocialLogin,
        alternativePhoneLogin,
        false,
      );
      this.addToggleListener(
        alternativePhoneLogin,
        phoneLoginForm,
        socialLogin,
        alternativeSocialLogin,
        alternativePhoneLogin,
        true,
      );
    }
  }

  setDisplayStyles(
    phoneLogin,
    socialLogin,
    altSocialLogin,
    altPhoneLogin,
    isPhoneLoginActive,
  ) {
    phoneLogin.style.display = isPhoneLoginActive ? "flex" : "none";
    socialLogin.style.display = isPhoneLoginActive ? "none" : "flex";
    altSocialLogin.style.display = isPhoneLoginActive ? "inline-flex" : "none";
    altPhoneLogin.style.display = isPhoneLoginActive ? "none" : "inline-flex";
  }

  addToggleListener(
    toggleElement,
    phoneLogin,
    socialLogin,
    altSocialLogin,
    altPhoneLogin,
    isPhoneLoginActive,
  ) {
    toggleElement.addEventListener("click", () => {
      this.setDisplayStyles(
        phoneLogin,
        socialLogin,
        altSocialLogin,
        altPhoneLogin,
        isPhoneLoginActive,
      );
    });
  }
}

customElements.define("sso-login-container", SsoLoginContainer);

class SsoLoginValidations extends HTMLElement {
  constructor() {
    super();
    this.errorToast = null;
    this.successToast = null;
  }

  connectedCallback() {
    this.errorToast = this.querySelector("login-error-toast");
    this.successToast = this.querySelector("login-success-toast");
  }

  showToast(type, message) {
    const toastElement =
      type === "success" ? this.successToast : this.errorToast;
    const messageElement = toastElement.querySelector(
      type === "success" ? "success-message" : "error-message",
    );

    messageElement.textContent = message;
    this.classList.add("active");
    toastElement.classList.add("active");
    this.animateToast(toastElement);
  }

  animateToast(toastElement) {
    const progressBar = toastElement.querySelector("toast-progress-bar");
    progressBar.style.width = "100%";

    requestAnimationFrame(() => {
      progressBar.style.transition = "width 3s linear";
      progressBar.style.width = "0%";
    });

    setTimeout(() => {
      this.hideToast(toastElement);
    }, 3000);
  }

  hideToast(toastElement) {
    toastElement.classList.remove("active");
    this.classList.remove("active");
    const progressBar = toastElement.querySelector("toast-progress-bar");
    progressBar.style.transition = "";
    progressBar.style.width = "100%";
  }

  showSuccessToast(message) {
    this.showToast("success", message);
  }

  showErrorToast(message) {
    this.showToast("error", message);
  }
}

customElements.define("sso-login-validations", SsoLoginValidations);

class PhoneLogin extends HTMLElement {
  constructor() {
    super();
    this.phoneNumber = "";
    this.countryCode = "";
    this.sessionId = "";
    this.validationsElement = null;
  }

  connectedCallback() {
    this.initPhoneLogin();
  }

  initPhoneLogin() {
    this.validationsElement = document.querySelector("sso-login-validations");
    const inputField = this.querySelector('input[name="phone-number"]');
    const continueButton = this.querySelector(".phone-login-button");
    const captchaButton = document.getElementById("captcha-button");
    const otpOnCallButton = document.querySelector("otp-on-call");

    this.disableButton(continueButton);
    inputField.addEventListener("input", () =>
      this.validatePhoneNumber(inputField, continueButton),
    );

    continueButton.addEventListener("click", (event) =>
      this.handleContinueClick(event, captchaButton, continueButton),
    );
    otpOnCallButton.addEventListener("click", (event) =>
      this.handleOtpOnCall(event, captchaButton),
    );
  }

  handleContinueClick(event, captchaButton, continueButton) {
    event.preventDefault();
    document.dispatchEvent(
      new CustomEvent("event:login:start", {
        detail: {
          method: "phone",
          phone: this.phoneNumber,
        },
      }),
    );
    this.toggleButtonState(continueButton, true);
    this.countryCode = this.querySelector(
      'input[name="countryCode"]',
    ).value.trim();

    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.sendOtpRequest(captchaButton, "send");
    } else {
      this.showError("Invalid phone number.", continueButton);
    }
  }

  handleOtpOnCall(event, captchaButton) {
    event.preventDefault();
    this.sendOtpRequest(captchaButton, "call");
  }

  sendOtpRequest(captchaButton, otpType) {
    captchaButton.setAttribute("data-otp-type", otpType);
    captchaButton.click();
  }

  validatePhoneNumber(inputField, continueButton) {
    this.phoneNumber = inputField?.value.trim();
    console.log("Phone Number:", this.phoneNumber);
    console.log("Country Code:", this.countryCode);
    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.enableButton(continueButton);
    } else {
      this.disableButton(continueButton);
    }
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  async handleRecaptchaToken(token) {
    const captchaButton = document.getElementById("captcha-button");
    const otpType = captchaButton.getAttribute("data-otp-type") || "send";

    try {
      await this.callApi(this.phoneNumber, token, this.countryCode, otpType);
    } catch (error) {
      console.error("ReCAPTCHA validation failed:", error);
      this.validationsElement.showErrorToast("ReCAPTCHA validation failed.");
      const continueButton = this.querySelector(".phone-login-button");
      this.toggleButtonState(continueButton, false);
    } finally {
      captchaButton.removeAttribute("data-otp-type");
    }
  }
  async getCustomerSession() {
    try {
      // Use centralized breeze SDK if available
      if (window.checkoutHelpers && typeof window.checkoutHelpers.fetchSession === 'function') {
        return await window.checkoutHelpers.fetchSession();
      }
      
      // Fallback to inline fetch
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();
      if (sessionData.customer) {
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }
  async callApi(phone, captcha, countryCode, otpType) {
    otpType = otpType || "sms";
    const continueButton = this.querySelector(".phone-login-button");

    try {
      const customerSession = await this.getCustomerSession();
      const shopifyYCookie = getCookie("_shopify_y");
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Device-ID": shopifyYCookie ?? "",
        },
        body: JSON.stringify({
          phone,
          countryCode,
          captcha,
          medium: otpType,
          cfUserId: customerSession?.cfUserId,
        }),
      };

      let url = "";
      let apiStage = "";
      
      if (!customerSession?.customer) {
        url = `${BASE_API_URL}/login/external/phone/otp/send`;
        apiStage = "otp_send_guest";
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        url = `${BASE_API_URL}/login/external/phone/update/otp/send`;
        apiStage = "otp_send_phone_update";
      } else {
        // User logged in with phone already set - unexpected state
        const error = new Error("User already has phone number set");
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureLoginError(error, {
            stage: 'otp_send_unexpected_state',
            method: 'phone',
            hasCustomer: !!customerSession?.customer,
            hasPhone: !!customerSession?.phone,
            phone: customerSession?.phone
          });
        }
        throw error;
      }
      
      if (window.CultStoreSentry) {
        window.CultStoreSentry.addBreadcrumb('Sending OTP request', 'login', {
          otpType,
          apiStage,
          hasSession: !!customerSession
        });
      }
      
      const response = await fetch(url, config);

      if (!response.ok) {
        const errorText = await response.text();
        const error = new Error(`HTTP ${response.status}: ${errorText}`);
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureAPIError(error, {
            endpoint: url,
            status: response.status,
            method: 'POST',
            stage: apiStage,
            responseText: errorText,
            phone: phone,
            otpType: otpType
          });
        }
        
        throw error;
      }

      const data = await response.json();
      console.log("OTP API Response:", data);
      
      if (!data.success) {
        const error = new Error(
          data.error || data.message || "Error occurred during OTP request."
        );
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureAPIError(error, {
            endpoint: url,
            status: response.status,
            method: 'POST',
            stage: apiStage,
            apiSuccess: false,
            apiError: data.error,
            apiMessage: data.message,
            phone: phone,
            otpType: otpType
          });
        }
        
        throw error;
      }
      
      this.sessionId = data?.data?.sessionId || "";
      
      if (!this.sessionId) {
        const error = new Error("No session ID received from OTP API");
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureAPIError(error, {
            endpoint: url,
            stage: apiStage,
            response: data
          });
        }
      }

      this.toggleButtonState(continueButton, false);
      this.handleOtpSuccess(otpType);
      
    } catch (error) {
      console.error("Error during OTP request:", error);
      
      // Determine if it's a network error or API error
      const isNetworkError = error.message.includes('fetch') || 
                             error.message.includes('network') ||
                             error.name === 'TypeError';
      
      if (window.CultStoreSentry && isNetworkError) {
        window.CultStoreSentry.captureNetworkError(error, {
          stage: 'otp_send',
          method: 'phone',
          phone: phone,
          otpType: otpType
        });
      }
      
      this.validationsElement.showErrorToast(error.message || "Error occurred during OTP request");
      this.toggleButtonState(continueButton, false);
      
      throw error;
    }
  }

  handleOtpSuccess(otpType) {
    let successMessage = "";
    switch (otpType) {
      case "resend":
        successMessage =
          "OTP has been resent to your phone number. Please check!";
        break;
      case "call":
        successMessage = "You will receive OTP on call shortly!";
        break;
      case "send":
      default:
        successMessage = "OTP sent successfully!";
        break;
    }
    this.validationsElement.showSuccessToast(successMessage);
    this.navigateToOtp(this.phoneNumber, this.sessionId);
  }

  toggleButtonState(button, isLoading) {
    if (!button) return;
    button.classList.toggle("is-loading", isLoading);
  }

  disableButton(button) {
    button?.setAttribute("disabled", "true");
  }

  enableButton(button) {
    button?.removeAttribute("disabled");
  }

  showError(message, button) {
    this.validationsElement.showErrorToast(message);
    this.toggleButtonState(button, false);
  }

  navigateToOtp(phoneNumber, sessionId) {
    const ssoLoginContainer = document.getElementById("sso-login-container");
    const ssoLoginOtp = document.querySelector("sso-login-otp");
    const otpOnCallElement = document.querySelector("otp-on-call");
    const otpTimerElement = document.querySelector("otp-timer");

    if (ssoLoginContainer && ssoLoginOtp) {
      ssoLoginContainer.classList.remove("active");
      ssoLoginOtp.classList.add("active");
      this.querySelector('input[name="phone-number"]').value = "";

      ssoLoginOtp.setPhoneNumber(phoneNumber, sessionId);
      if (otpOnCallElement && otpTimerElement) {
        this.otpTimerCountdown(15, otpTimerElement, otpOnCallElement);
      }
    }
  }

  otpTimerCountdown(duration, otpTimerElement, getOtpOnCallButton) {
    let timeLeft = duration;
    this.disableButton(getOtpOnCallButton);

    const intervalId = setInterval(() => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      otpTimerElement.textContent = ` in ${minutes < 10 ? "0" : ""}${minutes}:${
        seconds < 10 ? "0" : ""
      }${seconds}`;

      if (timeLeft <= 0) {
        clearInterval(intervalId);
        otpTimerElement.textContent = "";
        this.enableButton(getOtpOnCallButton);
      }

      timeLeft--;
    }, 1000);
  }
}

customElements.define("phone-login", PhoneLogin);

class SsoLoginOtp extends HTMLElement {
  constructor() {
    super();
    this.otpDigits = [];
    this.sessionId = "";
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.initOtpListeners();
    const otpValidationInput = document.getElementById("otp-validation-input");
    if (otpValidationInput) {
      otpValidationInput.focus(); // Ensure hidden input is the autofill target
    }
  }

  initOtpListeners() {
    const backButton = this.querySelector(".back--button");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById("otp-validation-input");
    const confirmButton = this.querySelector(".otp--confirm__button");
    const getHelpLink = this.querySelector(".get--help__link");

    otpHolders.forEach((holder, index) =>
      this.setupOtpHolder(holder, index, otpHolders, otpValidationInput),
    );

    // Listen for input events on the hidden input for autofill handling
    otpValidationInput.addEventListener("input", () =>
      this.handleOtpAutofill(otpValidationInput, otpHolders),
    );

    backButton?.addEventListener("click", this.handleBackButton.bind(this));
    confirmButton?.addEventListener(
      "click",
      this.handleConfirmButton.bind(this),
    );
    getHelpLink?.addEventListener("click", this.handleGetHelpLink.bind(this));
  }

  setupOtpHolder(holder, index, otpHolders, otpValidationInput) {
    holder.setAttribute("inputmode", "numeric");
    holder.setAttribute("autocomplete", "one-time-code");
    holder.style.caretColor = "black";
    holder.style.cursor = "text";

    holder.addEventListener("input", (event) =>
      this.handleOtpInput(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("keydown", (event) =>
      this.handleOtpBackspace(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("paste", (event) =>
      this.handleOtpPaste(event, otpHolders, otpValidationInput),
    );
  }

  handleOtpAutofill(otpValidationInput, otpHolders) {
    const otp = otpValidationInput.value.trim();
    if (/^\d{6}$/.test(otp)) {
      this.otpDigits = otp.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last field for UX
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpPaste(event, otpHolders, otpValidationInput) {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData || typeof clipboardData.getData !== "function") return;

    const paste = clipboardData.getData("text");
    if (/^\d{6}$/.test(paste)) {
      this.otpDigits = paste.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus();
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpInput(event, index, otpHolders, otpValidationInput) {
    const input = event.target.value.trim();

    if (index === 0 && /^\d{6}$/.test(input)) {
      // If the first input receives a 6-digit OTP (autofill case), distribute it
      this.otpDigits = input.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last input for UX
    } else if (/^\d$/.test(input)) {
      // If the input is a single digit, handle it normally
      this.otpDigits[index] = input;
      if (index < otpHolders.length - 1) {
        otpHolders[index + 1].focus(); // Move focus to the next field
      }
    } else {
      // If the input is invalid, clear the field
      event.target.value = "";
      this.otpDigits[index] = "";
    }

    this.updateOtpValue(otpValidationInput);
  }

  handleOtpBackspace(event, index, otpHolders, otpValidationInput) {
    if (event.key === "Backspace") {
      if (event.target.value) {
        event.target.value = "";
        this.otpDigits[index] = "";
      } else if (index > 0) {
        otpHolders[index - 1].focus();
        otpHolders[index - 1].value = "";
        this.otpDigits[index - 1] = "";
      }
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleBackButton() {
    const ssoLoginContainer = document.getElementById("sso-login-container");
    const phoneLogin = document.querySelector("phone-login");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById("otp-validation-input");
    const phoneLoginInputField = document.getElementById("phone-number");
    const phoneLoginContinueButton = document.querySelector(
      ".phone-login-button",
    );

    if (ssoLoginContainer) {
      ssoLoginContainer.classList.add("active");
      this.classList.remove("active");
      phoneLogin?.validatePhoneNumber(
        phoneLoginInputField,
        phoneLoginContinueButton,
      );

      this.otpDigits = this.otpDigits || new Array(otpHolders.length).fill("");
      otpHolders.forEach((holder, index) => {
        holder.value = "";
        this.otpDigits[index] = "";
      });
      otpValidationInput.value = "";
      this.toggleConfirmButton(true);
    }
  }

  handleConfirmButton() {
    const confirmButton = this.querySelector(".otp--confirm__button");
    if (confirmButton.hasAttribute("disabled")) return;

    confirmButton.classList.add("is-loading");
    document.querySelector("#verify-otp-form .g-recaptcha").click();
  }

  setPhoneNumber(phoneNumber, sessionId) {
    const otpPhoneElement = this.querySelector("otp-phone");
    if (otpPhoneElement) otpPhoneElement.textContent = phoneNumber;

    this.sessionId = sessionId;
  }

  updateOtpValue(otpValidationInput) {
    otpValidationInput.value = this.otpDigits.join("");
    this.toggleConfirmButton();
  }

  toggleConfirmButton() {
    const confirmButton = this.querySelector(".otp--confirm__button");
    const otpValidationInput = document.getElementById("otp-validation-input");

    if (otpValidationInput.value.length === 6) {
      confirmButton.removeAttribute("disabled");
    } else {
      confirmButton.setAttribute("disabled", "true");
    }
  }

  async callVerifyApi(otp, captcha, sessionId, return_to) {
    const customerSession = await this.getCustomerSession();
    
    try {
      let url = "";
      let apiStage = "";
      
      if (!customerSession?.customer) {
        url = `${BASE_API_URL}/login/external/phone/otp/verify`;
        apiStage = "otp_verify_guest";
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        url = `${BASE_API_URL}/login/external/phone/update/otp/verify`;
        apiStage = "otp_verify_phone_update";
      } else {
        // User logged in with phone already set - unexpected state
        const error = new Error("User already has phone number set");
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureLoginError(error, {
            stage: 'otp_verify_unexpected_state',
            method: 'phone',
            hasCustomer: !!customerSession?.customer,
            hasPhone: !!customerSession?.phone
          });
        }
        throw error;
      }
      
      if (window.CultStoreSentry) {
        window.CultStoreSentry.addBreadcrumb('Verifying OTP', 'login', {
          apiStage,
          hasSession: !!customerSession,
          hasSessionId: !!sessionId
        });
      }
      
      const shopifyYCookie = getCookie("_shopify_y");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Device-ID": shopifyYCookie ?? "",
        },
        body: JSON.stringify({
          otp,
          captcha,
          sessionId,
          return_to,
          cfUserId: customerSession?.cfUserId,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        const error = new Error(`HTTP ${response.status}: ${errorText}`);
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureAPIError(error, {
            endpoint: url,
            status: response.status,
            method: 'POST',
            stage: apiStage,
            responseText: errorText
          });
        }
        
        throw error;
      }

      const data = await response.json();
      console.log("OTP Verify API Response:", data);

      if (data.success) {
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        
        document.dispatchEvent(
          new CustomEvent("event:login:otp", {
            detail: {
              method: "phone",
              phone: this.phoneNumber,
              otpVerified: true,
            },
          }),
        );
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.addBreadcrumb('OTP verification successful', 'login', {
            cfUserId: data.data.cfUserId
          });
        }
        
        // Check if multipass URL exists
        if (!data.data.multipassUrl) {
          const error = new Error("No multipass URL received from verify API");
          if (window.CultStoreSentry) {
            window.CultStoreSentry.captureAPIError(error, {
              endpoint: url,
              stage: apiStage,
              response: data
            });
          }
          throw error;
        }
        
        window.location.href = data.data.multipassUrl;
      } else {
        // OTP verification failed
        this.handleInvalidOtp();
        
        document.dispatchEvent(
          new CustomEvent("event:login:otp", {
            detail: {
              method: "phone",
              phone: this.phoneNumber,
              otpVerified: false,
            },
          }),
        );
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureLoginError(new Error("Invalid OTP"), {
            stage: 'otp_verify_invalid',
            method: 'phone',
            apiSuccess: false,
            apiError: data.error,
            apiMessage: data.message
          });
        }
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      
      // Determine if it's a network error
      const isNetworkError = error.message.includes('fetch') || 
                             error.message.includes('network') ||
                             error.name === 'TypeError';
      
      if (window.CultStoreSentry && isNetworkError) {
        window.CultStoreSentry.captureNetworkError(error, {
          stage: 'otp_verify',
          method: 'phone'
        });
      }
      
      this.validationsElement?.showErrorToast(
        "Error occurred during OTP verification.",
      );
      document
        .querySelector("otp-confirm-button")
        ?.classList.remove("is-loading");
      
      throw error;
    }
  }

  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();

      if (sessionData.customer) {
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }

  handleInvalidOtp() {
    this.validationsElement?.showErrorToast("Invalid OTP.");
    document.querySelector("otp-confirm-button").classList.remove("is-loading");
  }

  onVerifySubmit(token) {
    const otp = document.getElementById("otp-validation-input").value;
    const return_to = window.location.href;

    this.callVerifyApi(otp, token, this.sessionId, return_to);
  }

  openBreezeCheckout(multipassUrl) {
    fetch(multipassUrl, { method: "GET", mode: "no-cors" })
      .then(() => document.querySelector("marmeto-checkout-button").click())
      .catch((error) => console.error("Error opening breeze checkout:", error));
  }

  handleGetHelpLink() {
    setTimeout(() => {
      this.validationsElement?.showErrorToast(
        "Please send us an email at hello@cultfit.com",
      );
    }, 2000);
  }
}

customElements.define("sso-login-otp", SsoLoginOtp);

class ResendOtpButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeButton();
  }

  initializeButton() {
    this.setAttribute("data-otp-type", "resend");
    this.addEventListener("click", this.handleResendClick.bind(this));
  }

  handleResendClick() {
    const phoneLogin = document.querySelector("phone-login");

    if (!phoneLogin) {
      console.error("Phone login element not found");
      return;
    }

    const { phoneNumber, validationsElement } = phoneLogin;

    if (!this.isValidPhoneNumber(phoneNumber)) {
      validationsElement.showErrorToast("Invalid phone number for resend.");
      return;
    }

    this.triggerCaptchaResend();
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  triggerCaptchaResend() {
    const captchaButton = document.getElementById("captcha-button");

    if (captchaButton) {
      captchaButton.setAttribute("data-otp-type", "resend");
      captchaButton.click();
    }
  }
}

customElements.define("resend-otp-button", ResendOtpButton);

class TruecallerLogin extends HTMLElement {
  constructor() {
    super();
    this.requestId = "";
    this.returnTo = window.location.href;
    this.intervalId = null;
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.addEventListener("click", this.onSubmit.bind(this));
  }

  async getDeepURL() {
    const url = `${BASE_API_URL}/login/external/truecaller/oauth/url`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: this.getDefaultHeaders(),
      });
      if (!response.ok) {
        this.showLoginError();
        return null;
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching Truecaller deep URL:", error);
      this.showLoginError();
      return null;
    }
  }

  async callApi() {
    if (!this.requestId) return;

    const url = `${BASE_API_URL}/login/external/truecaller/oauth/poll`;
    const payload = { requestId: this.requestId, return_to: this.returnTo };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.getDefaultHeaders(),
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        clearInterval(this.intervalId);
        return;
      }

      const data = await response.json();

      if (response.status === 200 && data.data?.multipassUrl) {
        clearInterval(this.intervalId);
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        // dispatch login complete event
        document.dispatchEvent(
          new CustomEvent("event:login:start", {
            detail: {
              method: "truecaller",
              phone: this.phoneNumber,
            },
          }),
        );
        window.location.href = data.data.multipassUrl;
      }
    } catch (error) {
      console.error("Error during Truecaller API call:", error);
      clearInterval(this.intervalId);
      this.showLoginError();
      this.showApiError(error.message);
    }
  }

  async onSubmit() {
    try {
      const response = await this.getDeepURL();
      console.log("Truecaller Login Response:", response);
      if (response?.data) {
        this.requestId = response.data.requestId;
        const loginUrl = response.data.url || response.data.deepLink;
        if (!loginUrl) {
          console.error("Truecaller login URL missing in response:", response);
          this.showLoginError();
          return;
        }
        window.location.href = loginUrl;
        this.intervalId = setInterval(() => this.callApi(), 1000);
      }
    } catch (error) {
      console.error("Error during Truecaller login:", error);
      this.showLoginError();
    }
  }

  getDefaultHeaders() {
    const shopifyYCookie = getCookie("_shopify_y");
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Device-ID": shopifyYCookie ?? "",
    };
  }

  showLoginError() {
    this.validationsElement?.showErrorToast(
      "Truecaller login failed. Try again later!",
    );
  }

  showApiError(message) {
    document.getElementById("truecaller-response").textContent =
      "Error: " + message;
  }
}

customElements.define("truecaller-login", TruecallerLogin);

class MarmetoCheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.customerInfo = null;
    this.checkoutPayload = {};
    this.userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = this.userAgent.includes("android");
    this.initiateCheckout = this.initiateCheckout.bind(this);
    this.addEventListener("click", this.initiateCheckout);
    // Reliability state
    this._active = false;
    this._attempt = 0;
  }

  async initiateCheckout() {
    if (this._active) {
      reportCheckoutError(CHECKOUT_ERROR_CODES.REENTRY, { attempt: this._attempt, phase: 'preflight' }, 'info');
      return;
    }
    this._active = true;
    this._attempt += 1;
    const attempt = this._attempt;
    const tx = startCheckoutTransaction();
    let phase = 'preflight';
    tagTransactionPhase(tx, phase);
    this._loadingStartTime = Date.now();
    this.toggleLoading(true);
    
    // Set global timeout for entire checkout flow (30 seconds)
    this._globalTimeout = setTimeout(() => {
      if (this._active) {
        const elapsedTime = Date.now() - this._loadingStartTime;
        reportCheckoutError('CHECKOUT_GLOBAL_TIMEOUT', {
          attempt,
          phase,
          elapsedTime,
          isStillLoading: this.hasAttribute('loading'),
          buttonDisabled: this.hasAttribute('disabled')
        });
        this.toggleLoading(false);
        this._active = false;
        
        // Show user-friendly error
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureSilentFailure(
            'Checkout timed out after 30 seconds',
            { type: 'global_timeout', phase, elapsedTime }
          );
        }
      }
    }, 30000);
    
    // Monitor for stuck loading state (check every 5 seconds)
    this._stuckDetectionTimer = setInterval(() => {
      if (this._active && this.hasAttribute('loading')) {
        const elapsedTime = Date.now() - this._loadingStartTime;
        if (elapsedTime > 15000) { // Stuck for more than 15 seconds
          reportCheckoutBreadcrumb('checkout_stuck_warning', {
            elapsedTime,
            phase,
            attempt,
            hasPayload: !!this.checkoutPayload
          });
        }
      }
    }, 5000);
    const finish = (status, code) => {
      // Clear all timers
      if (this._globalTimeout) {
        clearTimeout(this._globalTimeout);
        this._globalTimeout = null;
      }
      if (this._stuckDetectionTimer) {
        clearInterval(this._stuckDetectionTimer);
        this._stuckDetectionTimer = null;
      }
      
      // Track checkout duration
      const duration = this._loadingStartTime ? Date.now() - this._loadingStartTime : null;
      if (duration && window.CultStoreSentry) {
        window.CultStoreSentry.addBreadcrumb('checkout_completed', 'checkout', {
          status,
          code,
          duration,
          attempt
        });
      }
      
      finalizeTransaction(tx, status, code);
      this.toggleLoading(false);
      this._active = false;
      this._loadingStartTime = null;
      
      // Re-enable button for flows that intentionally diverted (login / phone capture)
      if (status === 'success' && (code === 'LOGIN_FLOW' || code === 'PHONE_FLOW')) {
        this.removeAttribute('disabled');
      }
      
      // Track failed attempts for analytics
      if (status === 'failed' && window.CultStoreSentry) {
        const errorData = window.CultStoreSentry.getFlattenedErrorData(code, {
          category: window.CultStoreSentry.ERROR_CATEGORIES.CHECKOUT,
          message: `Checkout failed at ${phase}`,
          stage: phase,
          attempt,
          duration
        });
        
        // Send to analytics
        try {
          if (window.DataLake && typeof window.DataLake.captureEvent === 'function') {
            window.DataLake.captureEvent('checkout_failed', errorData);
          }
        } catch (e) {
          console.warn('Failed to send checkout error to DataLake:', e);
        }
      }
    };

    try {
      // Preflight cart emptiness check with actual fetch
      try {
        const cartCheckResponse = await fetch('/cart.json');
        if (cartCheckResponse.ok) {
          const cartData = await cartCheckResponse.json();
          if (!cartData || !Array.isArray(cartData.items) || cartData.items.length === 0) {
            reportCheckoutError(CHECKOUT_ERROR_CODES.CART_EMPTY, { 
              attempt, 
              phase,
              cartData: cartData ? { itemCount: cartData.item_count, total: cartData.total_price } : null
            });
            finish('aborted', CHECKOUT_ERROR_CODES.CART_EMPTY);
            return;
          }
          // Update window.cart for consistency
          window.cart = cartData;
        } else {
          // Fallback to window.cart if fetch fails
          if (window.cart && Array.isArray(window.cart.items) && window.cart.items.length === 0) {
            reportCheckoutError(CHECKOUT_ERROR_CODES.CART_EMPTY, { attempt, phase, fallback: true });
            finish('aborted', CHECKOUT_ERROR_CODES.CART_EMPTY);
            return;
          }
        }
      } catch (cartCheckError) {
        // Log but don't block - continue with checkout
        reportCheckoutBreadcrumb('cart_check_failed', { error: cartCheckError.message, phase });
      }

      // Session fetch with timeout + single retry on timeout
      phase = 'session'; tagTransactionPhase(tx, phase);
      let sessionData; let lastErrCode;
      for (let i = 0; i < 2; i++) {
        try {
          sessionData = await withTimeout(this.getCustomerSession(), 6000, CHECKOUT_ERROR_CODES.SESSION_TIMEOUT);
          break;
        } catch (e) {
          const code = e._checkoutCode === CHECKOUT_ERROR_CODES.SESSION_TIMEOUT ? CHECKOUT_ERROR_CODES.SESSION_TIMEOUT : CHECKOUT_ERROR_CODES.SESSION_ERROR;
            lastErrCode = code;
            reportCheckoutError(code, { attempt, phase, retry: i, message: e.message });
            if (code === CHECKOUT_ERROR_CODES.SESSION_TIMEOUT && i === 0) continue; // retry once
            break;
        }
      }
      // If session fetch succeeded but user not logged in (getCustomerSession returns null), treat as guest login flow.
      if (!sessionData) {
        phase = 'login'; tagTransactionPhase(tx, phase);
        if (typeof this.showPhoneUpdateModal === 'function') {
          this.showPhoneUpdateModal();
          finish('success', 'LOGIN_FLOW');
          return;
        } else {
          reportCheckoutError(CHECKOUT_ERROR_CODES.UNKNOWN, { attempt, phase, detail: 'showPhoneUpdateModal missing (guest)' });
          finish('failed', CHECKOUT_ERROR_CODES.UNKNOWN);
          return;
        }
      }

      const isLoggedIn = !!sessionData.customer;
      const hasPhone = !!sessionData.phone;

      // Logged in but missing phone -> show phone update modal and exit (expected flow)
      if (isLoggedIn && !hasPhone) {
        phase = 'phone'; tagTransactionPhase(tx, phase);
        if (typeof this.showPhoneUpdateModal === 'function') {
          this.showPhoneUpdateModal();
          finish('success', 'PHONE_FLOW');
          return;
        } else {
          reportCheckoutError(CHECKOUT_ERROR_CODES.PHONE_MODAL_MISSING, { attempt, phase });
          finish('failed', CHECKOUT_ERROR_CODES.PHONE_MODAL_MISSING);
          return;
        }
      }

      // (Guest path already handled above when sessionData was null)

      // Prepare payload (timeout + retry on timeout code only)
      phase = 'payload'; tagTransactionPhase(tx, phase);
      let payloadOk = false; let payloadErr;
      for (let i = 0; i < 2; i++) {
        try {
          await withTimeout(this.prepareCheckoutPayload(), 8000, CHECKOUT_ERROR_CODES.PAYLOAD_API_TIMEOUT);
          payloadOk = true;
          break;
        } catch (e) {
          const code = e._checkoutCode === CHECKOUT_ERROR_CODES.PAYLOAD_API_TIMEOUT ? CHECKOUT_ERROR_CODES.PAYLOAD_API_TIMEOUT : CHECKOUT_ERROR_CODES.PAYLOAD_BUILD_ERROR;
          payloadErr = code;
          reportCheckoutError(code, { attempt, phase, retry: i, message: e.message });
          if (code === CHECKOUT_ERROR_CODES.PAYLOAD_API_TIMEOUT && i === 0) continue; // retry once
          break;
        }
      }
      if (!payloadOk) {
        finish('failed', payloadErr || CHECKOUT_ERROR_CODES.PAYLOAD_BUILD_ERROR);
        return;
      }

      // SDK readiness
      phase = 'sdk_wait'; tagTransactionPhase(tx, phase);
      const sdkReady = await waitForBreezeSDK();
      if (!sdkReady) {
        reportCheckoutError(CHECKOUT_ERROR_CODES.BREEZE_SDK_UNAVAILABLE, { attempt, phase });
        finish('failed', CHECKOUT_ERROR_CODES.BREEZE_SDK_UNAVAILABLE);
        return;
      }

      // Launch
      phase = 'sdk_launch'; tagTransactionPhase(tx, phase);
      try {
        this.startCheckout();
      } catch (e) {
        reportCheckoutError(CHECKOUT_ERROR_CODES.BREEZE_START_FAILED, { attempt, phase, message: e.message });
        finish('failed', CHECKOUT_ERROR_CODES.BREEZE_START_FAILED);
        return;
      }

      finish('success', 'COMPLETE');
    } catch (e) {
      const code = e && e._checkoutCode ? e._checkoutCode : CHECKOUT_ERROR_CODES.UNKNOWN;
      reportCheckoutError(code, { attempt, phase, message: e.message || String(e) });
      finish('failed', code);
    }
  }

  async getCustomerSession() {
    const startTime = Date.now();
    
    try {
      reportCheckoutBreadcrumb('fetching_customer_session', 'checkout');
      
      // Use centralized breeze SDK if available
      if (window.checkoutHelpers && typeof window.checkoutHelpers.fetchSession === 'function') {
        try {
          const sessionData = await window.checkoutHelpers.fetchSession();
          const fetchDuration = Date.now() - startTime;
          
          reportCheckoutBreadcrumb('session_fetched_centralized', {
            hasCustomer: !!sessionData?.customer,
            hasPayload: !!sessionData?.breezePayload,
            duration: fetchDuration
          });
          
          if (sessionData && sessionData.customer) {
            this.checkoutPayload = sessionData.breezePayload;
          }
          return sessionData;
        } catch (centralizedError) {
          const fetchDuration = Date.now() - startTime;
          
          reportCheckoutBreadcrumb('centralized_session_failed', {
            error: centralizedError.message,
            duration: fetchDuration
          });
          
          // Fall through to inline fetch
        }
      }
      
      // Fallback to inline fetch
      reportCheckoutBreadcrumb('fetching_session_inline', 'checkout');
      
      const response = await fetch("/cart?view=breeze");
      
      if (!response.ok) {
        const fetchDuration = Date.now() - startTime;
        const error = new Error(`Session fetch failed with status ${response.status}`);
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureAPIError(error, {
            endpoint: '/cart?view=breeze',
            status: response.status,
            statusText: response.statusText,
            duration: fetchDuration,
            stage: 'session_fetch',
            level: response.status === 401 ? window.CultStoreSentry.ERROR_LEVELS.LOW : window.CultStoreSentry.ERROR_LEVELS.HIGH
          });
        }
        
        throw error;
      }
      
      const sessionData = await response.json();
      const fetchDuration = Date.now() - startTime;

      reportCheckoutBreadcrumb('session_fetched_inline', {
        hasCustomer: !!sessionData?.customer,
        hasPayload: !!sessionData?.breezePayload,
        duration: fetchDuration
      });

      if (sessionData.customer) {
        this.checkoutPayload = sessionData.breezePayload;
        return sessionData;
      }

      return null;
    } catch (error) {
      const fetchDuration = Date.now() - startTime;
      console.error("Error fetching customer session:", error);
      
      // Report to Sentry with comprehensive context
      if (window.CultStoreSentry) {
        window.CultStoreSentry.captureNetworkError(error, {
          endpoint: '/cart?view=breeze',
          duration: fetchDuration,
          stage: 'session_fetch',
          method: 'getCustomerSession',
          errorMessage: error.message,
          errorStack: error.stack,
          isTimeout: error.name === 'AbortError' || fetchDuration > 5000,
          level: window.CultStoreSentry.ERROR_LEVELS.CRITICAL
        });
      }
      
      // Create detailed error for retry logic
      const detailedError = new Error("Unable to verify customer session: " + error.message);
      detailedError._checkoutCode = CHECKOUT_ERROR_CODES.SESSION_ERROR;
      detailedError.originalError = error;
      throw detailedError;
    }
  }

  async prepareCheckoutPayload() {
    try {
      reportCheckoutBreadcrumb('preparing_payload', 'checkout');
      
      const response = await fetch("/cart.json");
      
      if (!response.ok) {
        const error = new Error(`Cart fetch failed with status ${response.status}`);
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureAPIError(error, {
            endpoint: '/cart.json',
            status: response.status,
            statusText: response.statusText,
            stage: 'cart_fetch',
            level: window.CultStoreSentry.ERROR_LEVELS.CRITICAL
          });
        }
        
        throw error;
      }
      
      const cart = await response.json();
      
      if (!cart || typeof cart !== 'object') {
        const error = new Error('Invalid cart data received');
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureCheckoutError(error, {
            stage: 'cart_parse',
            cartType: typeof cart,
            cartData: String(cart).substring(0, 100)
          });
        }
        
        throw error;
      }
      
      const appliedOffer = resilientStorage.getJSONLocal('appliedOffer');

      this.checkoutPayload.payload.cart = cart;
      
      // Track storage operations with error handling
      try {
        localStorage.setItem("gaPxCart", JSON.stringify(cart));
      } catch (storageError) {
        reportCheckoutBreadcrumb('localStorage_write_failed', {
          key: 'gaPxCart',
          error: storageError.message,
          size: JSON.stringify(cart).length
        });
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureSilentFailure(
            'Failed to write cart to localStorage',
            { type: 'storage_write', key: 'gaPxCart', error: storageError.message }
          );
        }
      }
      
      const breezeItemsArray = cart.items.map(item => ({
        id: item.id,
        name: item.title,
        variant: item.variant_id,
        item_brand: item.vendor,
        quantity: item.quantity,
        price: item.price / 100, // Convert to INR
        currency: "INR",
        vendor: item.vendor,
        productType: item.product_type,
      }));
      
      try {
        localStorage.setItem("gaPxCartItems", JSON.stringify(breezeItemsArray));
      } catch (storageError) {
        reportCheckoutBreadcrumb('localStorage_write_failed', {
          key: 'gaPxCartItems',
          error: storageError.message,
          itemCount: breezeItemsArray.length
        });
      }
      
      if (appliedOffer) {
        this.checkoutPayload.payload.offers = [
          {
            id: appliedOffer.id,
            code: appliedOffer.code,
          },
        ];
      }

      // Determine TAT date based on current time
      try {
        const currentISTDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
        const tatHour = 18; // 6 PM IST
        const cutoffHour = 15; // 3 PM IST

        let tatDate;
        if (currentISTDate.getHours() < cutoffHour) {
          // If current time is before 3 PM IST, set TAT to today at 6 PM IST
          tatDate = new Date(currentISTDate.setHours(tatHour, 0, 0, 0));
        } else {
          // If current time is after 3 PM IST, set TAT to tomorrow at 6 PM IST
          tatDate = new Date(currentISTDate.setDate(currentISTDate.getDate() + 1));
          tatDate.setHours(tatHour, 0, 0, 0);
        }

        const formattedDate = tatDate.toISOString().split('T')[0] + 'T18:00:00+05:30';

        this.checkoutPayload.payload.cart.attributes = {
          ...this.checkoutPayload.payload.cart.attributes,
          "FULFILLMENT TAT": formattedDate,
        };
        
        reportCheckoutBreadcrumb('tat_calculated', { formattedDate, cutoffPassed: currentISTDate.getHours() >= cutoffHour });
      } catch (tatError) {
        reportCheckoutBreadcrumb('tat_calculation_failed', { error: tatError.message });
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureSilentFailure(
            'TAT calculation failed, proceeding without TAT',
            { type: 'tat_calculation', error: tatError.message }
          );
        }
        // Continue without TAT if calculation fails
      }

    } catch (error) {
      console.error("Error preparing checkout payload:", error);
      
      // Report to Sentry with comprehensive context
      if (window.CultStoreSentry) {
        window.CultStoreSentry.captureCheckoutError(error, {
          stage: 'payload_preparation',
          method: 'prepareCheckoutPayload',
          errorMessage: error.message,
          errorStack: error.stack,
          pageUrl: window.location.href,
          hasPayload: !!this.checkoutPayload,
          payloadStructure: this.checkoutPayload ? Object.keys(this.checkoutPayload) : null,
          level: window.CultStoreSentry.ERROR_LEVELS.CRITICAL
        });
      }
      
      // Create detailed error for retry logic
      const detailedError = new Error("Checkout payload preparation failed: " + error.message);
      detailedError._checkoutCode = CHECKOUT_ERROR_CODES.PAYLOAD_BUILD_ERROR;
      detailedError.originalError = error;
      throw detailedError;
    }
  }

  startCheckout() {
    try {
      // Use centralized breeze SDK if available
      try {
        if (window.checkoutHelpers && typeof window.checkoutHelpers.startCheckout === 'function') {
          const { isWebview, android } = detectWebview(true);
          this.handlePushState();
          
          if (window.CultStoreSentry) {
            window.CultStoreSentry.addBreadcrumb('Starting checkout via centralized SDK', 'checkout', {
              isWebview,
              android,
              hasPayload: !!this.checkoutPayload
            });
          }
          
          return window.checkoutHelpers.startCheckout(this.checkoutPayload, isWebview, android);
        }
      } catch (e) {
        console.warn("Centralized breeze SDK checkout start failed, falling back to inline. Error:", e);
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureSDKError(e, {
            sdkName: 'centralized_breeze',
            stage: 'start_checkout',
            fallbackAvailable: true
          });
        }
      }
      
      // Fallback to inline implementation
      const isApp = localStorage.getItem("isApp");
      const { android, isWebview } = detectWebview(true);
      
      if (window.CultStoreSentry) {
        window.CultStoreSentry.addBreadcrumb('Starting checkout inline', 'checkout', {
          isApp,
          isWebview,
          android,
          hasReactNativeWebView: !!window.ReactNativeWebView,
          hasBlazeSDK: !!window.BlazeSDK,
          hasPayload: !!this.checkoutPayload
        });
      }
      
      // Detect if we're in app context but ReactNativeWebView is missing
      if (isWebview && isApp && (!window.ReactNativeWebView || typeof window.ReactNativeWebView.postMessage !== "function")) {
        const error = new Error("In app webview but ReactNativeWebView.postMessage unavailable");
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureSDKError(error, {
            sdkName: 'react_native_webview',
            stage: 'validation',
            isWebview,
            isApp,
            hasReactNativeWebView: !!window.ReactNativeWebView,
            hasPostMessage: typeof window.ReactNativeWebView?.postMessage === 'function'
          });
        }
        
        console.error("ReactNativeWebView not available in app context, falling back to BlazeSDK");
      }
      
      if (
        isWebview &&
        isApp &&
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === "function"
      ) {
        // Native app checkout flow
        let nativePayload = {
          action: "blazeStartNativeCheckout",
          data: {
            ...this.checkoutPayload,
            payload: {
              ...this.checkoutPayload.payload,
              safeMargin: {
                top: android ? 40 : 0,
              },
            },
          },
        };
        
        const breezeItemsArray = localStorage.getItem("gaPxCartItems")
          ? JSON.parse(localStorage.getItem("gaPxCartItems"))
          : this.checkoutPayload.payload.cart.items.map(item => ({
            id: item.id,
            name: item.title,
            variant: item.variant_id,
            item_brand: item.vendor,
            quantity: item.quantity,
            price: item.price / 100,
            currency: "INR",
            vendor: item.vendor,
            productType: item.product_type,
          }));
        
        // Track analytics
        try {
          if (window.gtag) {
            window.gtag('event', 'begin_checkout', {
              send_to: "G-ZWHZKTYB0D",
              currency: "INR",
              value: this.checkoutPayload.payload.cart.total_price,
              items: breezeItemsArray,
              breeze_event_type: 'breeze_checkout_initiated',
              breeze_event_time: new Date().toISOString()
            });
          }
        } catch (e) {
          console.warn('GA4 tracking failed:', e);
        }
        
        try {
          if (window.fbq) {
            window.fbq(
              'track',
              "InitiateCheckout",
              {
                content_type: 'product_group',
                value: this.checkoutPayload.payload.cart.total_price / 100,
                content_ids: breezeItemsArray.map(item => item.id),
                contents: breezeItemsArray,
                num_items: breezeItemsArray.length,
                currency: "INR",
              },
              {
                eventID: `breeze_checkout_${Date.now()}`,
              }
            );
          }
        } catch (e) {
          console.warn('Facebook pixel tracking failed:', e);
        }
        
        try {
          window.ReactNativeWebView.postMessage(JSON.stringify(nativePayload));
          console.log("Native checkout payload sent");
          
          if (window.CultStoreSentry) {
            window.CultStoreSentry.addBreadcrumb('Native checkout initiated', 'checkout', {
              payloadSize: JSON.stringify(nativePayload).length
            });
          }
        } catch (e) {
          const error = new Error("Failed to post message to React Native WebView");
          
          if (window.CultStoreSentry) {
            window.CultStoreSentry.captureSDKError(error, {
              sdkName: 'react_native_webview',
              stage: 'post_message',
              originalError: e.message
            });
          }
          
          throw error;
        }
        
      } else if (window.BlazeSDK && this.checkoutPayload) {
        // Web checkout flow
        this.handlePushState();
        
        try {
          if (typeof window.BlazeSDK.process !== 'function') {
            throw new Error("BlazeSDK.process is not a function");
          }
          
          window.BlazeSDK.process(this.checkoutPayload);
          
          if (window.CultStoreSentry) {
            window.CultStoreSentry.addBreadcrumb('BlazeSDK checkout initiated', 'checkout', {
              payloadSize: JSON.stringify(this.checkoutPayload).length
            });
          }
        } catch (e) {
          const error = new Error("BlazeSDK.process failed: " + e.message);
          
          if (window.CultStoreSentry) {
            window.CultStoreSentry.captureSDKError(error, {
              sdkName: 'blaze_sdk',
              stage: 'process',
              hasBlazeSDK: !!window.BlazeSDK,
              hasProcess: typeof window.BlazeSDK?.process === 'function',
              originalError: e.message
            });
          }
          
          throw error;
        }
        
      } else {
        // Neither SDK available
        const error = new Error("Blaze SDK unavailable or payload missing");
        
        if (window.CultStoreSentry) {
          window.CultStoreSentry.captureSDKError(error, {
            sdkName: 'blaze_sdk',
            stage: 'availability_check',
            hasBlazeSDK: !!window.BlazeSDK,
            hasPayload: !!this.checkoutPayload,
            hasReactNativeWebView: !!window.ReactNativeWebView,
            isWebview: isWebview,
            isApp: !!isApp,
            userAgent: navigator.userAgent,
            level: window.CultStoreSentry.ERROR_LEVELS.CRITICAL
          });
        }
        
        throw error;
      }
    } catch (error) {
      console.error("Checkout rendering error:", error);
      
      // Only capture if not already captured above
      if (window.CultStoreSentry && 
          !error.message.includes("unavailable or payload missing") &&
          !error.message.includes("BlazeSDK.process failed") &&
          !error.message.includes("Failed to post message")) {
        window.CultStoreSentry.captureCheckoutError(error, {
          stage: 'sdk_launch_exception',
          method: 'startCheckout',
          errorMessage: error.message,
          errorStack: error.stack,
        });
      }
      
      throw error;
    }
  }

  triggerLoginPopup() {
    const loginModal = document.querySelector("sso-login");

    if (loginModal) {
      document.querySelector("sso-login").togglePopup();
      resilientStorage.setCriticalOpenCheckout();
    }
  }

  showPhoneUpdateModal() {
    const phoneUpdateModal = document.querySelector("#cart-drawer-login-body");
    const cartDrawerLoginModal = document.querySelector("cart-drawer-login");
    const cartDrawerTruecaller = document.querySelector(
      "cart-drawer-truecaller-login",
    );

    if (cartDrawerLoginModal) {
      cartDrawerLoginModal.classList.add("active");
    }
    if (phoneUpdateModal) {
      if (this.isAndroid) {
        cartDrawerTruecaller.classList.remove("hidden");
        cartDrawerTruecaller.checkAndOpenTruecaller();
      }
      phoneUpdateModal.classList.add("active");
      document.body.classList.add("overflow-hidden");
      this.setAttribute("disabled", "true");
      resilientStorage.setCriticalOpenCheckout();
    }
  }

  toggleLoading(isLoading) {
    // Track state changes for debugging
    if (window.CultStoreSentry && isLoading !== this.classList.contains('is-loading')) {
      window.CultStoreSentry.addBreadcrumb(
        isLoading ? 'checkout_loading_started' : 'checkout_loading_stopped',
        'ui',
        {
          wasLoading: this.classList.contains('is-loading'),
          nowLoading: isLoading,
          attempt: this._attempt,
          elapsedTime: this._loadingStartTime ? Date.now() - this._loadingStartTime : 0
        }
      );
    }
    
    this.classList.toggle("is-loading", isLoading);
    this.style.disable = isLoading;
    this.style.cursor = isLoading ? "not-allowed" : "pointer";
    this.style.pointerEvents = isLoading ? "none" : "auto";
    this.style.opacity = isLoading ? "0.5" : "1";
    this.style.transition = "opacity 0.3s ease-in-out";
    
    // Also update aria-busy for accessibility
    if (isLoading) {
      this.setAttribute('aria-busy', 'true');
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('aria-busy');
      // Only remove disabled if not in a waiting state (login/phone)
      if (!this._active) {
        this.removeAttribute('disabled');
      }
    }
  }

  handlePushState() {
    const currentUrl = window.location.href;
    history.pushState(null, "", currentUrl);

    window.onpopstate = function () {
      window.location.reload();
    };
  }
}

customElements.define("marmeto-checkout-button", MarmetoCheckoutButton);

class GoogleLogin extends HTMLElement {
  constructor() {
    super();
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.addEventListener("click", this.handleLogin.bind(this));
  }

  async handleLogin() {
    try {
      const shopifyYCookie = getCookie("_shopify_y");
      const response = await fetch(
        `${BASE_API_URL}/login/external/google/oauth/url`,
        {
          headers: {
            "X-Device-ID": shopifyYCookie ?? "",
          },
        },
      );

      if (!response.ok) {
        this.showLoginError();
        return;
      }

      const data = await response.json();

      if (data?.success && data?.data?.url) {
        window.location.href = data.data.url;
      } else {
        this.showLoginError();
      }
    } catch (error) {
      console.error("Google login error:", error);
      this.showLoginError();
    }
  }

  showLoginError() {
    this.validationsElement?.showErrorToast(
      "Google login failed. Try again later!",
    );
  }
}

customElements.define("google-login", GoogleLogin);

function onSubmit(token) {
  // Helper function to process phone login components
  function handlePhoneLogin(selector, buttonSelector) {
    const phoneLogin = document.querySelector(selector);
    const phoneLoginButton = document.querySelector(buttonSelector);

    // Proceed if the button is not disabled
    if (phoneLoginButton && !phoneLoginButton.hasAttribute("disabled")) {
      if (phoneLogin) {
        phoneLogin.handleRecaptchaToken(token); // Handle the token
      } else {
        phoneLoginButton.classList.remove("is-loading"); // Ensure loading state is reset
        phoneLoginButton.removeAttribute("disabled");
      }
    }
  }

  // Handle both phone login components
  handlePhoneLogin(
    "cart-drawer-phone-login",
    ".cart-drawer-phone-login-button",
  );
  handlePhoneLogin("phone-login", ".phone-login-button");
}

function onVerifySubmit(token) {
  // Helper function to process OTP components
  function handleOtpLogin(selector) {
    const otpComponent = document.querySelector(selector);
    const confirmButton = otpComponent?.querySelector(".otp--confirm__button");

    // Proceed if the confirm button is not disabled
    if (confirmButton && !confirmButton.hasAttribute("disabled")) {
      otpComponent.onVerifySubmit(token); // Handle the token
    }
  }

  // Handle both OTP components
  handleOtpLogin("cart-drawer-login-otp");
  handleOtpLogin("sso-login-otp");
}

// cart drawer login
class CartDrawerPhoneLogin extends HTMLElement {
  constructor() {
    super();
    this.phoneNumber = "";
    this.countryCode = "";
    this.sessionId = "";
    this.validationsElement = null;
  }

  connectedCallback() {
    this.initPhoneLogin();
  }

  initPhoneLogin() {
    this.validationsElement = document.querySelector("sso-login-validations");
    const inputField = this.querySelector('input[id="cartDrawerPhoneNumber"]');
    const continueButton = this.querySelector(
      ".cart-drawer-phone-login-button",
    );
    const captchaButton = document.getElementById("cart-drawer-captcha-button");
    // const otpOnCallButton = document.querySelector('cart-drawer-otp-on-call');

    this.disableButton(continueButton);
    inputField.addEventListener("input", () =>
      this.validatePhoneNumber(inputField, continueButton),
    );

    continueButton.addEventListener("click", (event) =>
      this.handleContinueClick(event, captchaButton, continueButton),
    );
    // otpOnCallButton.addEventListener('click', (event) => this.handleOtpOnCall(event, captchaButton));
  }

  handleContinueClick(event, captchaButton, continueButton) {
    event.preventDefault();
    this.toggleButtonState(continueButton, true);
    this.countryCode = this.querySelector(
      'input[id="cartDrawerCountryCode"]',
    ).value.trim();
    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.sendOtpRequest(captchaButton, "send");
    } else {
      this.showError("Invalid phone number.", continueButton);
    }
  }

  // handleOtpOnCall(event, captchaButton) {
  //   event.preventDefault();
  //   this.sendOtpRequest(captchaButton, 'call');
  // }

  sendOtpRequest(captchaButton, otpType) {
    captchaButton.setAttribute("data-otp-type", otpType);
    captchaButton.click();
  }

  validatePhoneNumber(inputField, continueButton) {
    this.phoneNumber = inputField?.value.trim();
    if (this.isValidPhoneNumber(this.phoneNumber)) {
      this.enableButton(continueButton);
    } else {
      this.disableButton(continueButton);
    }
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  async handleRecaptchaToken(token) {
    const captchaButton = document.getElementById("cart-drawer-captcha-button");
    const otpType = captchaButton.getAttribute("data-otp-type") || "send";

    try {
      await this.callApi(this.phoneNumber, token, this.countryCode, otpType);
    } catch (error) {
      console.error("ReCAPTCHA validation failed:", error);
      this.validationsElement.showErrorToast("ReCAPTCHA validation failed.");
      const continueButton = this.querySelector(".cart-drawer-phone-login-button");
      this.toggleButtonState(continueButton, false);
    } finally {
      captchaButton.removeAttribute("data-otp-type");
    }
  }
  async getCustomerSession() {
    try {
      // Use centralized breeze SDK if available
      if (window.checkoutHelpers && typeof window.checkoutHelpers.fetchSession === 'function') {
        return await window.checkoutHelpers.fetchSession();
      }
      
      // Fallback to inline fetch
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();
      if (sessionData.customer) {
        return sessionData;
      }
      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }
  async callApi(phone, captcha, countryCode, otpType) {
    otpType = otpType || "sms";
    const continueButton = this.querySelector(
      ".cart-drawer-phone-login-button",
    );

    const customerSession = await this.getCustomerSession();
    const shopifyYCookie = getCookie("_shopify_y");
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Device-ID": shopifyYCookie ?? "",
      },
      body: JSON.stringify({
        phone,
        countryCode,
        captcha,
        medium: otpType,
        cfUserId: customerSession?.cfUserId,
      }),
    };

    try {
      let url = "";
      if (!customerSession?.customer) {
        url = `${BASE_API_URL}/login/external/phone/otp/send`;
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        const cfUserId = customerSession?.cfUserId;
        url = `${BASE_API_URL}/login/external/phone/otp/send`;
      } else {
        // todo:: log and report error here
        return;
      }
      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("OTP Request Response:", data);
      if (!data.success) {
        throw new Error(
          data.error || data.message || "Error occurred during OTP request.",
        );
      }
      this.sessionId = data?.data?.sessionId || data?.data?.session_id || "";

      this.toggleButtonState(continueButton, false);
      this.handleOtpSuccess(otpType);
    } catch (error) {
      console.error("Phone login/update error:", error);
      this.validationsElement.showErrorToast(error.message);
      this.toggleButtonState(continueButton, false);
    }
  }

  handleOtpSuccess(otpType) {
    let successMessage = "";
    switch (otpType) {
      case "resend":
        successMessage =
          "OTP has been resent to your phone number. Please check!";
        break;
      case "call":
        successMessage = "You will receive OTP on call shortly!";
        break;
      case "send":
      default:
        successMessage = "OTP sent successfully!";
        break;
    }
    this.validationsElement.showSuccessToast(successMessage);
    this.navigateToOtp(this.phoneNumber, this.sessionId);
  }

  toggleButtonState(button, isLoading) {
    if (!button) return;
    button.classList.toggle("is-loading", isLoading);
  }

  disableButton(button) {
    button?.setAttribute("disabled", "true");
  }

  enableButton(button) {
    button?.removeAttribute("disabled");
  }

  showError(message, button) {
    this.validationsElement.showErrorToast(message);
    this.toggleButtonState(button, false);
  }

  navigateToOtp(phoneNumber, sessionId) {
    const ssoLoginContainer = document.getElementById("cart-drawer-login-body");
    const ssoLoginOtp = document.querySelector("cart-drawer-login-otp");
    if (ssoLoginContainer && ssoLoginOtp) {
      ssoLoginContainer.classList.remove("active");
      ssoLoginOtp.classList.add("active");
      this.querySelector('input[name="phone-number"]').value = "";

      ssoLoginOtp.setPhoneNumber(sessionId);
    }
  }
}

customElements.define("cart-drawer-phone-login", CartDrawerPhoneLogin);

class CartDrawerLoginOtp extends HTMLElement {
  constructor() {
    super();
    this.otpDigits = [];
    this.sessionId = "";
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.initOtpListeners();
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );
    if (otpValidationInput) {
      otpValidationInput.focus(); // Ensure hidden input is the autofill target
    }
  }

  initOtpListeners() {
    const backButton = this.querySelector(".back--button");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );
    const confirmButton = this.querySelector(".otp--confirm__button");
    const getHelpLink = this.querySelector(".get--help__link");

    otpHolders.forEach((holder, index) =>
      this.setupOtpHolder(holder, index, otpHolders, otpValidationInput),
    );

    // Listen for input events on the hidden input for autofill handling
    otpValidationInput.addEventListener("input", () =>
      this.handleOtpAutofill(otpValidationInput, otpHolders),
    );

    backButton?.addEventListener("click", this.handleBackButton.bind(this));
    confirmButton?.addEventListener(
      "click",
      this.handleConfirmButton.bind(this),
    );
    getHelpLink?.addEventListener("click", this.handleGetHelpLink.bind(this));
  }

  setupOtpHolder(holder, index, otpHolders, otpValidationInput) {
    holder.setAttribute("inputmode", "numeric");
    holder.setAttribute("autocomplete", "one-time-code");
    holder.style.caretColor = "black";
    holder.style.cursor = "text";

    holder.addEventListener("input", (event) =>
      this.handleOtpInput(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("keydown", (event) =>
      this.handleOtpBackspace(event, index, otpHolders, otpValidationInput),
    );
    holder.addEventListener("paste", (event) =>
      this.handleOtpPaste(event, otpHolders, otpValidationInput),
    );
  }

  handleOtpAutofill(otpValidationInput, otpHolders) {
    const otp = otpValidationInput.value.trim();
    if (/^\d{6}$/.test(otp)) {
      this.otpDigits = otp.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last field for UX
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpPaste(event, otpHolders, otpValidationInput) {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    if (!clipboardData || typeof clipboardData.getData !== "function") return;

    const paste = clipboardData.getData("text");
    if (/^\d{6}$/.test(paste)) {
      this.otpDigits = paste.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus();
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleOtpInput(event, index, otpHolders, otpValidationInput) {
    const input = event.target.value.trim();

    if (index === 0 && /^\d{6}$/.test(input)) {
      // If the first input receives a 6-digit OTP (autofill case), distribute it
      this.otpDigits = input.split("");
      otpHolders.forEach((holder, idx) => {
        holder.value = this.otpDigits[idx];
      });
      otpHolders[otpHolders.length - 1].focus(); // Focus on the last input for UX
    } else if (/^\d$/.test(input)) {
      // If the input is a single digit, handle it normally
      this.otpDigits[index] = input;
      if (index < otpHolders.length - 1) {
        otpHolders[index + 1].focus(); // Move focus to the next field
      }
    } else {
      // If the input is invalid, clear the field
      event.target.value = "";
      this.otpDigits[index] = "";
    }

    this.updateOtpValue(otpValidationInput);
  }

  handleOtpBackspace(event, index, otpHolders, otpValidationInput) {
    if (event.key === "Backspace") {
      if (event.target.value) {
        event.target.value = "";
        this.otpDigits[index] = "";
      } else if (index > 0) {
        otpHolders[index - 1].focus();
        otpHolders[index - 1].value = "";
        this.otpDigits[index - 1] = "";
      }
      this.updateOtpValue(otpValidationInput);
    }
  }

  handleBackButton() {
    const ssoLoginContainer = document.getElementById("cart-drawer-login-body");
    const phoneLogin = document.querySelector("cart-drawer-phone-login");
    const otpHolders = [...this.querySelectorAll(".otp--holder")];
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );
    const cartDrawerInputField = document.getElementById(
      "cartDrawerPhoneNumber",
    );
    const cartDrawerContinueButton = document.querySelector(
      ".cart-drawer-phone-login-button",
    );

    if (ssoLoginContainer) {
      ssoLoginContainer.classList.add("active");
      this.classList.remove("active");
      phoneLogin?.validatePhoneNumber(
        cartDrawerInputField,
        cartDrawerContinueButton,
      );

      this.otpDigits = this.otpDigits || new Array(otpHolders.length).fill("");
      otpHolders.forEach((holder, index) => {
        holder.value = "";
        this.otpDigits[index] = "";
      });
      otpValidationInput.value = "";
      this.toggleConfirmButton(true);
    }
  }

  handleConfirmButton() {
    const confirmButton = this.querySelector(".otp--confirm__button");
    if (confirmButton.hasAttribute("disabled")) return;

    confirmButton.classList.add("is-loading");
    document.querySelector("#cart-drawer-verify-otp-form .g-recaptcha").click();
  }

  setPhoneNumber(sessionId) {
    this.sessionId = sessionId;
  }

  updateOtpValue(otpValidationInput) {
    otpValidationInput.value = this.otpDigits.join("");
    this.toggleConfirmButton();
  }

  toggleConfirmButton(disable = false) {
    const confirmButton = this.querySelector(".otp--confirm__button");
    const otpValidationInput = document.getElementById(
      "cart-drawer-otp-validation-input",
    );

    if (disable || otpValidationInput.value.length !== 6) {
      confirmButton.setAttribute("disabled", "true");
    } else {
      confirmButton.removeAttribute("disabled");
    }
  }

  async callVerifyApi(otp, captcha, sessionId, return_to) {
    const customerSession = await this.getCustomerSession();
    try {
      let url = "";
      if (!customerSession?.customer) {
        url = `${BASE_API_URL}/login/external/phone/otp/verify`;
      } else if (
        customerSession.customer &&
        (!customerSession?.phone || customerSession?.phone == "")
      ) {
        url = `${BASE_API_URL}/login/external/phone/update/otp/verify`;
      } else {
        // todo:: log and report error here
        return;
      }
      const shopifyYCookie = getCookie("_shopify_y");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Device-ID": shopifyYCookie ?? "",
        },
        body: JSON.stringify({
          otp,
          captcha,
          sessionId,
          return_to,
          cfUserId: customerSession?.cfUserId,
        }),
      });

      const data = await response.json();
      console.log("OTP Verification Response:", data);
      if (!response.ok) throw new Error("Network response was not ok");

      if (data.success) {
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        window.location.href = data.data.multipassUrl;
      } else {
        this.handleInvalidOtp();
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      this.validationsElement?.showErrorToast(
        "Error occurred during OTP verification.",
      );
      document
        .querySelector("cart-drawer-otp-confirm-button")
        .classList.remove("is-loading");
    }
  }

  async getCustomerSession() {
    try {
      const response = await fetch("/cart?view=breeze");
      const sessionData = await response.json();

      if (sessionData.customer) {
        return sessionData;
      }

      return null;
    } catch (error) {
      console.error("Error fetching customer session:", error);
      throw new Error("Unable to verify customer session");
    }
  }

  handleInvalidOtp() {
    this.validationsElement?.showErrorToast("Invalid OTP.");
    document
      .querySelector("cart-drawer-otp-confirm-button")
      .classList.remove("is-loading");
  }

  onVerifySubmit(token) {
    const otp = document.getElementById(
      "cart-drawer-otp-validation-input",
    ).value;
    const return_to = window.location.href;

    this.callVerifyApi(otp, token, this.sessionId, return_to);
  }

  openBreezeCheckout(multipassUrl) {
    fetch(multipassUrl, { method: "GET", mode: "no-cors" })
      .then(() => document.querySelector("marmeto-checkout-button").click())
      .catch((error) => console.error("Breeze checkout opening error:", error));
  }
}

customElements.define("cart-drawer-login-otp", CartDrawerLoginOtp);

class CartDrawerResendOtpButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeButton();
  }

  initializeButton() {
    this.setAttribute("data-otp-type", "resend");
    this.addEventListener("click", this.handleResendClick.bind(this));
  }

  handleResendClick() {
    const phoneLogin = document.querySelector("cart-drawer-phone-login");

    if (!phoneLogin) {
      console.error("Phone login element not found");
      return;
    }

    const { phoneNumber, validationsElement } = phoneLogin;

    if (!this.isValidPhoneNumber(phoneNumber)) {
      validationsElement.showErrorToast("Invalid phone number for resend.");
      return;
    }

    this.triggerCaptchaResend();
  }

  isValidPhoneNumber(phoneNumber) {
    return /^[6-9]\d{9,11}$/.test(phoneNumber);
  }

  triggerCaptchaResend() {
    const captchaButton = document.getElementById("cart-drawer-captcha-button");

    if (captchaButton) {
      captchaButton.setAttribute("data-otp-type", "resend");
      captchaButton.click();
    }
  }
}

customElements.define(
  "cart-drawer-resend-otp-button",
  CartDrawerResendOtpButton,
);

class CartDrawerTruecallerLogin extends HTMLElement {
  constructor() {
    super();
    this.userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = this.userAgent.includes("android");
    this.requestId = "";
    this.returnTo = window.location.href;
    this.intervalId = null;
    this.validationsElement = document.querySelector("sso-login-validations");
  }

  connectedCallback() {
    this.addEventListener("click", this.onSubmit.bind(this));
  }

  checkAndOpenTruecaller() {
    let isTruecallerInstalled = false;
    const truecallerURL = "truecaller://";
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = truecallerURL;
    document.body.appendChild(iframe);

    requestAnimationFrame(() => {
      setTimeout(() => {
        if (isTruecallerInstalled) {
          this?.onSubmit();
        }
        document.body.removeChild(iframe);
      }, 500);
    });

    window.addEventListener(
      "blur",
      () => {
        isTruecallerInstalled = true;
      },
      { once: true },
    );
  }

  async getDeepURL() {
    const url = `${BASE_API_URL}/login/external/truecaller/oauth/url`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: this.getDefaultHeaders(),
      });
      if (!response.ok) {
        this.showLoginError();
        return null;
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching deep URL for Truecaller:", error);
      this.showLoginError();
      return null;
    }
  }

  async callApi() {
    if (!this.requestId) return;

    const url = `${BASE_API_URL}/login/external/truecaller/oauth/poll`;
    const payload = { requestId: this.requestId, return_to: this.returnTo };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this.getDefaultHeaders(),
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        clearInterval(this.intervalId);
        return;
      }

      const data = await response.json();
      if (response.status === 200 && data.data?.multipassUrl) {
        clearInterval(this.intervalId);
        Shopify.analytics.publish("userRegistered", {
          cfUserId: data.data.cfUserId,
        });
        window.location.href = data.data.multipassUrl;
      }
    } catch (error) {
      console.error("Error polling Truecaller API:", error);
      clearInterval(this.intervalId);
      this.showLoginError();
      this.showApiError(error.message);
    }
  }

  async onSubmit() {
    try {
      const response = await this.getDeepURL();
      console.log("Truecaller Login Response:", response);
      if (response?.data) {
        this.requestId = response.data.requestId;
        window.location.href = response.data.url;
        this.intervalId = setInterval(() => this.callApi(), 1000);
      }
    } catch (error) {
      console.error("Error during Truecaller login submission:", error);
      this.showLoginError();
    }
  }

  getDefaultHeaders() {
    const shopifyYCookie = getCookie("_shopify_y");
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Device-ID": shopifyYCookie ?? "",
    };
  }

  showLoginError() {
    this.validationsElement?.showErrorToast(
      "Truecaller login failed. Try again later!",
    );
  }

  showApiError(message) {
    document.getElementById("cart-drawer-truecaller-response").textContent =
      "Error: " + message;
  }
}

customElements.define(
  "cart-drawer-truecaller-login",
  CartDrawerTruecallerLogin,
);
